import * as React from 'react';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { StepsWrapper, Step } from '../../uiComponents/Steps';
import Login from '../login/Login';
import { RouteComponentProps } from 'react-router';
import { isAuthenticated } from '../../infrastructure/Security';
import { Redirect } from 'react-router-dom';

export interface TilmeldingLoginProps extends RouteComponentProps<any> {

}

class TilmeldingLogin extends React.Component<TilmeldingLoginProps, {}> {
    constructor(props: TilmeldingLoginProps) {
      super(props);
      
    }    

    render() {
        if (isAuthenticated()) {
            return <Redirect to='/tilmelding/vaelg-konkurrence' />;
        } else {
            return (
                <ContentWrapper>
                    <StepsWrapper>
                        <Step href='/tilmelding/login' label='1' state='active'>
                            Login
                        </Step>
                        <Step href='#' label='2' state='ahead'>
                            Vælg konkurrence
                        </Step>
                        <Step href='#' label='3' state='ahead'>
                            Tilmeld hold
                        </Step>
                        <Step href='#' label='4' state='ahead'>
                            Bekræft
                        </Step>
                    </StepsWrapper>
                    <Login                     
                        redirectTo='/tilmelding/vaelg-konkurrence'
                        fromTilmeldingFlow={true}
                        {...this.props}                     
                    />               
    
                </ContentWrapper>
            );
        }
    }
}

export default TilmeldingLogin;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/tilmelding/TilmeldingLogin.tsx